module.exports = __webpack_public_path__ + "static/media/4b_website_logo_sup_ashhkchp.28764be3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4b_website_logo_sup_ashhkchp.jpg
// module id = 55
// module chunks = 0